module.exports = __webpack_public_path__ + "img/mail.45890b0a.svg";